import { appConfig } from '@/config/app.config';
import { formatMoney } from '@/utils/money';
import { MOBILE_PATTERN } from '@/utils/phone';

import type { InvoiceDetail } from '../schemas/invoice.schema';

/** The amounts, one per line: what the bill came to, and what is settled or still owed. */
function amountLines(invoice: InvoiceDetail): string[] {
  const total = `Total: ${formatMoney(invoice.total)}`;
  if (invoice.paymentState === 'paid') return [total, 'Status: Paid in full'];
  if (invoice.paymentState === 'partly') {
    return [
      total,
      `Paid: ${formatMoney(invoice.amountPaid)}`,
      `Balance due: ${formatMoney(invoice.dueAmount)}`,
    ];
  }
  return [total, `Balance due: ${formatMoney(invoice.dueAmount)}`];
}

/**
 * The WhatsApp message that goes with a bill: plain, polite and short, ending in the download
 * link. No emojis, by the owner's choice.
 */
export function invoiceWhatsappMessage(invoice: InvoiceDetail, link: string): string {
  const gym = appConfig.app.name;
  return [
    `Hello ${invoice.member.firstName},`,
    '',
    `Thank you for choosing ${gym}. Your invoice for ${invoice.description} is ready.`,
    '',
    `Invoice no: ${invoice.invoiceNumber}`,
    ...amountLines(invoice),
    '',
    'Download your invoice here:',
    link,
    '',
    'We look forward to seeing you at the gym. Keep up the great work!',
    '',
    `Team ${gym}`,
  ].join('\n');
}

/**
 * The address that opens WhatsApp with `message` typed in. With a valid mobile it opens that
 * member's chat (Indian numbers, so `91` goes in front); without one WhatsApp asks who to send to.
 */
export function whatsappUrl(mobile: string, message: string): string {
  const text = encodeURIComponent(message);
  return MOBILE_PATTERN.test(mobile)
    ? `https://wa.me/91${mobile}?text=${text}`
    : `https://wa.me/?text=${text}`;
}
